import { HomePictures } from "../../data/home/home";

const portfolioLabelKeys = {
    "/portrait": "nav.portrait",
    "/wedding": "nav.wedding",
    "/event": "nav.event",
    "/commercial": "nav.commercial",
    "/pets": "nav.pets",
    "/fashion": "nav.fashion",
    "/destination": "nav.destination",
    "/creative": "nav.creative",
    "/scenery": "nav.scenery",
};

export const portfolioLinks = HomePictures.filter((item) => item.link).map((item) => ({
    to: item.link,
    labelKey: portfolioLabelKeys[item.link] || item.nameKey,
}));

export const aboutLink = { to: "/about", labelKey: "nav.about" };
export const contactLink = { to: "/contact", labelKey: "nav.contact" };
export const photographyLink = { to: "/photography", labelKey: "nav.photography" };
export const creatorPartnershipsLink = {
    to: "/creator-partnerships",
    labelKey: "nav.creatorPartnerships",
};

const portfolioPaths = portfolioLinks.map((link) => link.to);

export function isPhotographyView(pathname = "") {
    return (
        pathname === "/" ||
        pathname === photographyLink.to ||
        portfolioPaths.includes(pathname)
    );
}

export function isCreatorPartnershipsView(pathname = "") {
    return pathname === creatorPartnershipsLink.to;
}

export const drawerNavLinks = [
    aboutLink,
    photographyLink,
    creatorPartnershipsLink,
    contactLink,
];
